import { render } from "./CrInstallInstruction.vue?vue&type=template&id=96f73f8e&scoped=true"
import script from "./CrInstallInstruction.vue?vue&type=script&lang=js"
export * from "./CrInstallInstruction.vue?vue&type=script&lang=js"

import "./CrInstallInstruction.vue?vue&type=style&index=0&id=96f73f8e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f73f8e"]])

export default __exports__